import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable, from } from 'rxjs';

export interface ConfirmationDialogConfig {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'warning' | 'danger' | 'info' | 'success';
}

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private dialogData$$ = new BehaviorSubject<any>(null);

  private dialogRef!: NgbModalRef;

  constructor(private ngbModal: NgbModal) {}

  public open(dialogBox: any, extras?: { options?: NgbModalOptions; data?: any }): NgbModalRef {
    if (extras?.data) {
      this.dialogData$$.next(extras.data);
    }
    this.dialogRef = this.ngbModal.open(dialogBox, { centered: true, keyboard: false, ...extras?.options });
    return this.dialogRef;
  }

  public dismiss() {
    this.dialogRef.dismiss();
  }

  public close(data?: any) {
    this.dialogRef.close(data);
  }

  public get dialogData$(): Observable<any> {
    return this.dialogData$$.asObservable();
  }

  public openConfirmation(config: ConfirmationDialogConfig): Observable<boolean> {
    return from(
      import('../components/confirmation-dialog/confirmation-dialog.component').then(({ ConfirmationDialogComponent }) => {
        const modalRef = this.open(ConfirmationDialogComponent, {
          data: config,
          options: {
            backdrop: 'static',
            keyboard: false,
            size: 'md',
          },
        });

        return modalRef.result.then(
          (result) => result === true,
          () => false,
        );
      }),
    );
  }
}
